import { render, staticRenderFns } from "./support4iQ.vue?vue&type=template&id=13a141e0&"
import script from "./support4iQ.vue?vue&type=script&lang=js&"
export * from "./support4iQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13a141e0')) {
      api.createRecord('13a141e0', component.options)
    } else {
      api.reload('13a141e0', component.options)
    }
    module.hot.accept("./support4iQ.vue?vue&type=template&id=13a141e0&", function () {
      api.rerender('13a141e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/components/support4iQ.vue"
export default component.exports